// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
   overflow: hidden;
   width:600px;
   height: 450px!important;
}
.main {
   width: 600px;
   min-width: 600px;
   max-width: 600px;
   overflow-y: hidden;
   max-height: 400px;
   min-height: 400px;
}
.folders {
   list-style: none;
   margin: 0;
   padding: 0;
}
li {
   margin-top: 8px;
   position: relative;
   white-space: nowrap;
}
a {
   color: #666;
   cursor: pointer;
   display: inline-block;
   line-height: 20px;
   margin-left: 45px;
   padding-right: 5px;
   position: relative;
   word-break: break-all;
}
a:hover {
   color: #ffa726;
}
i {
   display: block;
   line-height: 20px;
   width: 20px;
   height: 20px;
   text-align: center;
   transition: transform .3s;
   position: absolute;
   top: 0;
   left: 0;
}
i.fa-spinner {
   left: -1px;
}
.expanded {
   transform: rotate(90deg);
}
.error {
   margin-left: 8px;
   margin-top: 5px;
}
a.selectedPath {
   color: #00bed6;
}
a.denied {
   cursor: default;
   color: #a7a6a6;
   text-decoration: none;
}
.denied img {
   filter: grayscale(100%);
   opacity: .8;
}

.actions {
   height: 350px;
   overflow-x: hidden;
   overflow-y: scroll;
   padding: 10px;
   background-color: #f5f5f5;
}

.hideSearch {
   height: 400px;
}

.list-container{
   margin-top: -10px;
}

ul {
   list-style: none;
   margin: 0;
   padding: 0;
}

.section-break {
   height: 20px;
}

li.section {
   font-weight: bold;
   padding: 5px 5px 5px 20px;
}


a.social-link:hover {
   color: #ffa726;
   cursor: pointer;
}

a.active {
   color: #ff8326;
   cursor: initial;
}

a.active:hover {
   text-decoration: none;
}

i, .mat-icon {
   display: block;
   line-height: 20px;
   width: 20px;
   height: 20px;
   text-align: center;
   transition: transform .3s;
   position: absolute;
   top: 0;
   left: -20px;
}

img {
   display: block;
   width: 20px;
   height: 20px;
   position: absolute;
   top: 0;
   left: -25px;
}

.sub_tasks {
   padding-left: 16px;
}

i.fa-briefcase {
   font-size: 16px;
}

i:not(.caret):before {
   vertical-align: middle;
}

i.caret {
   cursor: default;
   font-size: inherit;
   left: 1px;
   top: 0;
}

i.expanded {
   transform: rotate(90deg);
}

app-folders,
app-google-drive-folders,
app-one-drive-folders,
app-dropbox-folders{
   display: block;
   margin-left: 16px;
}
.cannot{
   color: #a7a6a6;
   cursor:default;
   text-decoration:none;
}
.cannot:hover{
   color: #a7a6a6!important;
   text-decoration:none;
}
.button-form{
   padding: 8px 0;
}
.name,.desc{
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}
.desc{
   padding-left: 55px;
   color: #999;
   font-size: 12px;
}

.loading-container {
   overflow: hidden;
   width:600px;
   height: 407px!important;
}

.notfound-container {
   overflow: hidden;
   width:600px;
   height: 250px!important;
}

.notfound {
   text-align: center;
   position: absolute;
   top: 50%;
   left: 30%;
   right: 30%;
   padding-top: -11px;
}

@media (min-width: 480px) {
   .list-container {
      max-width: 100%;
   }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) { }
@media only screen and (min-width: 480px) and (max-width: 768px) {
   .list-container {
      min-width: 768px;
      width: 768px;
   }
}
@media only screen and (max-width: 480px) {
   .list-container {
      min-width: 480px;
      width: 480px;
   }
}

.checkBox{
   width: 5px;
   margin-left: 5px
}
.search-form{
   margin-top:10px;
   margin-bottom:10px;
   width: 90%;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/tasks/select-file-document/select-file-document.component.css"],"names":[],"mappings":"AAAA;GACG,gBAAgB;GAChB,WAAW;GACX,uBAAuB;AAC1B;AACA;GACG,YAAY;GACZ,gBAAgB;GAChB,gBAAgB;GAChB,kBAAkB;GAClB,iBAAiB;GACjB,iBAAiB;AACpB;AACA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;AACA;GACG,eAAe;GACf,kBAAkB;GAClB,mBAAmB;AACtB;AACA;GACG,WAAW;GACX,eAAe;GACf,qBAAqB;GACrB,iBAAiB;GACjB,iBAAiB;GACjB,kBAAkB;GAClB,kBAAkB;GAClB,qBAAqB;AACxB;AACA;GACG,cAAc;AACjB;AACA;GACG,cAAc;GACd,iBAAiB;GACjB,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,yBAAyB;GACzB,kBAAkB;GAClB,MAAM;GACN,OAAO;AACV;AACA;GACG,UAAU;AACb;AACA;GACG,wBAAwB;AAC3B;AACA;GACG,gBAAgB;GAChB,eAAe;AAClB;AACA;GACG,cAAc;AACjB;AACA;GACG,eAAe;GACf,cAAc;GACd,qBAAqB;AACxB;AACA;GACG,uBAAuB;GACvB,WAAW;AACd;;AAEA;GACG,aAAa;GACb,kBAAkB;GAClB,kBAAkB;GAClB,aAAa;GACb,yBAAyB;AAC5B;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,iBAAiB;GACjB,yBAAyB;AAC5B;;;AAGA;GACG,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,cAAc;GACd,iBAAiB;GACjB,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,yBAAyB;GACzB,kBAAkB;GAClB,MAAM;GACN,WAAW;AACd;;AAEA;GACG,cAAc;GACd,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,MAAM;GACN,WAAW;AACd;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,sBAAsB;AACzB;;AAEA;GACG,eAAe;GACf,kBAAkB;GAClB,SAAS;GACT,MAAM;AACT;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;;;;GAIG,cAAc;GACd,iBAAiB;AACpB;AACA;GACG,cAAc;GACd,cAAc;GACd,oBAAoB;AACvB;AACA;GACG,wBAAwB;GACxB,oBAAoB;AACvB;AACA;GACG,cAAc;AACjB;AACA;GACG,gBAAgB;GAChB,uBAAuB;GACvB,mBAAmB;AACtB;AACA;GACG,kBAAkB;GAClB,WAAW;GACX,eAAe;AAClB;;AAEA;GACG,gBAAgB;GAChB,WAAW;GACX,uBAAuB;AAC1B;;AAEA;GACG,gBAAgB;GAChB,WAAW;GACX,uBAAuB;AAC1B;;AAEA;GACG,kBAAkB;GAClB,kBAAkB;GAClB,QAAQ;GACR,SAAS;GACT,UAAU;GACV,kBAAkB;AACrB;;AAEA;GACG;MACG,eAAe;GAClB;AACH;AACA,oEAAoE;AACpE;GACG;MACG,gBAAgB;MAChB,YAAY;GACf;AACH;AACA;GACG;MACG,gBAAgB;MAChB,YAAY;GACf;AACH;;AAEA;GACG,UAAU;GACV;AACH;AACA;GACG,eAAe;GACf,kBAAkB;GAClB,UAAU;AACb","sourcesContent":[".container {\n   overflow: hidden;\n   width:600px;\n   height: 450px!important;\n}\n.main {\n   width: 600px;\n   min-width: 600px;\n   max-width: 600px;\n   overflow-y: hidden;\n   max-height: 400px;\n   min-height: 400px;\n}\n.folders {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\nli {\n   margin-top: 8px;\n   position: relative;\n   white-space: nowrap;\n}\na {\n   color: #666;\n   cursor: pointer;\n   display: inline-block;\n   line-height: 20px;\n   margin-left: 45px;\n   padding-right: 5px;\n   position: relative;\n   word-break: break-all;\n}\na:hover {\n   color: #ffa726;\n}\ni {\n   display: block;\n   line-height: 20px;\n   width: 20px;\n   height: 20px;\n   text-align: center;\n   transition: transform .3s;\n   position: absolute;\n   top: 0;\n   left: 0;\n}\ni.fa-spinner {\n   left: -1px;\n}\n.expanded {\n   transform: rotate(90deg);\n}\n.error {\n   margin-left: 8px;\n   margin-top: 5px;\n}\na.selectedPath {\n   color: #00bed6;\n}\na.denied {\n   cursor: default;\n   color: #a7a6a6;\n   text-decoration: none;\n}\n.denied img {\n   filter: grayscale(100%);\n   opacity: .8;\n}\n\n.actions {\n   height: 350px;\n   overflow-x: hidden;\n   overflow-y: scroll;\n   padding: 10px;\n   background-color: #f5f5f5;\n}\n\n.hideSearch {\n   height: 400px;\n}\n\n.list-container{\n   margin-top: -10px;\n}\n\nul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n\n.section-break {\n   height: 20px;\n}\n\nli.section {\n   font-weight: bold;\n   padding: 5px 5px 5px 20px;\n}\n\n\na.social-link:hover {\n   color: #ffa726;\n   cursor: pointer;\n}\n\na.active {\n   color: #ff8326;\n   cursor: initial;\n}\n\na.active:hover {\n   text-decoration: none;\n}\n\ni, .mat-icon {\n   display: block;\n   line-height: 20px;\n   width: 20px;\n   height: 20px;\n   text-align: center;\n   transition: transform .3s;\n   position: absolute;\n   top: 0;\n   left: -20px;\n}\n\nimg {\n   display: block;\n   width: 20px;\n   height: 20px;\n   position: absolute;\n   top: 0;\n   left: -25px;\n}\n\n.sub_tasks {\n   padding-left: 16px;\n}\n\ni.fa-briefcase {\n   font-size: 16px;\n}\n\ni:not(.caret):before {\n   vertical-align: middle;\n}\n\ni.caret {\n   cursor: default;\n   font-size: inherit;\n   left: 1px;\n   top: 0;\n}\n\ni.expanded {\n   transform: rotate(90deg);\n}\n\napp-folders,\napp-google-drive-folders,\napp-one-drive-folders,\napp-dropbox-folders{\n   display: block;\n   margin-left: 16px;\n}\n.cannot{\n   color: #a7a6a6;\n   cursor:default;\n   text-decoration:none;\n}\n.cannot:hover{\n   color: #a7a6a6!important;\n   text-decoration:none;\n}\n.button-form{\n   padding: 8px 0;\n}\n.name,.desc{\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n}\n.desc{\n   padding-left: 55px;\n   color: #999;\n   font-size: 12px;\n}\n\n.loading-container {\n   overflow: hidden;\n   width:600px;\n   height: 407px!important;\n}\n\n.notfound-container {\n   overflow: hidden;\n   width:600px;\n   height: 250px!important;\n}\n\n.notfound {\n   text-align: center;\n   position: absolute;\n   top: 50%;\n   left: 30%;\n   right: 30%;\n   padding-top: -11px;\n}\n\n@media (min-width: 480px) {\n   .list-container {\n      max-width: 100%;\n   }\n}\n@media only screen and (min-width: 768px) and (max-width: 1024px) { }\n@media only screen and (min-width: 480px) and (max-width: 768px) {\n   .list-container {\n      min-width: 768px;\n      width: 768px;\n   }\n}\n@media only screen and (max-width: 480px) {\n   .list-container {\n      min-width: 480px;\n      width: 480px;\n   }\n}\n\n.checkBox{\n   width: 5px;\n   margin-left: 5px\n}\n.search-form{\n   margin-top:10px;\n   margin-bottom:10px;\n   width: 90%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
